import RestService from './RestService';

export async function getPage(domain, url) {
	const res = await RestService.performRestOpNext(`page/get-raw-authorizer`, {
		domain, url
	});
	console.log(res);
	return res;
}


export async function createPage(page) {
	console.log(page);
	const res = await RestService.performRestOpNext(`page/create`, page);
	console.log("response ------>", res);
	return { domain: page.domain, url: page.url };
}

export async function updatePage(page) {
	console.log(page);
	const res = await RestService.performRestOpNext(`page/update`, page);
	console.log(res);
	return res;
}